export const FILTER_OPERATOR_ENUM = {
    EQUAL: { label: "=", value: "EQUAL" },
    GREATER_THAN: { label: ">", value: "GREATER_THAN" },
    MINUS_THAN: { label: "<", value: "MINUS_THAN" },
    IN: { label: "∈", value: "IN" },
    NOT_IN: { label: "∉", value: "NOT_IN" },
    ASC: { label: "descendant", value: "DESCENDING" },
    DSC: { label: "ascendant", value: "ASCENDING" },
};